import type { CollectorType } from 'providers/HostedScrapingProvider';

import { iconType, isAiResultsBetaActive, isAiResultsProject, projectTypeToTitleAndDescription } from "sdecontent";
import { projectIcon } from "components/hosted-scraping/ProjectIcon";
import Badge from "components/Badge";
import { cx } from 'utils';
import { ProjectVariant } from 'sdecontent';

export const ProjectDetailsHead = ({variant, configType}: {variant: ProjectVariant, configType: CollectorType}) => {
  const Icon = projectIcon(iconType(variant, configType));
  const { title, description } = projectTypeToTitleAndDescription(variant, configType);
  const iconBackground = configType === 'async_urls' ? 'bg-primary-600/[0.08] dark:bg-neutral-50' : '';
  const iconStyle = cx("w-14 h-14 p-2 shrink-0 border border-solid mr-4 border-lightGray-600 dark:border-neutral-200 flex items-center justify-center", iconBackground);
  return (
  <div className="h-14 w-full flex flex-row items-center">
    <div className={iconStyle}>
      <div className="h-7 flex items-center justify-center"> <Icon/></div>
    </div>
    <div className="shrink">
      <div className="flex items-center gap-2">
        <div className="text-lg font-semibold text-brandDarkest dark:text-primary-800">{title}</div>
        { isAiResultsProject(configType) && isAiResultsBetaActive() && <Badge text="Beta" /> }
      </div>
      <div className="text-sm font-normal text-gray-600 dark:text-neutral-600">{description}</div>
    </div>
  </div>);
}
